import React, { Suspense } from "react";
import Loader from "../General/loader";

export default function (components: any): any {
    const { Content } = components;

    function WithoutSidebar(props: any) {
        return (
            <div className="Content Content--withoutSidebar">
                <Suspense fallback={<Loader />}>
                    <Content {...props} />
                </Suspense>
            </div>
        );
    }

    return WithoutSidebar;
}
